import api from '../../../app/api';
import { TemplateCollection } from '../models/template-collection';
import { TemplateDetails } from '../models/template-details';
import { TemplateField } from '../models/template-field';

import { Template } from '../models/template';

export const templatesApi = api
  .enhanceEndpoints({
    addTagTypes: ['Templates'],
  })
  .injectEndpoints({
    endpoints: builder => ({
      getTemplates: builder.query<Template[], void>({
        query: () => ({
          url: '/portal-api/v1/templates',
        }),
        providesTags: ['Templates'],
      }),
      getTemplateCollections: builder.query<TemplateCollection[], void>({
        query: () => ({
          url: '/portal-api/v1/templates/collections',
        }),
        providesTags: ['Templates'],
      }),
      getTemplatesUnassigned: builder.query<Template[], void>({
        query: () => ({
          url: '/portal-api/v1/templates/unassigned',
        }),
        providesTags: ['Templates'],
      }),
      getTemplate: builder.query<TemplateDetails, string>({
        query: templateId => ({
          url: `/portal-api/v1/templates/${templateId}`,
        }),
      }),
      getTemplateFields: builder.query<TemplateField[], string>({
        query: templateId => ({
          url: `/portal-api/v1/templates/${templateId}/fields`,
        }),
      }),
    }),
    overrideExisting: false,
  });

export const {
  useGetTemplatesQuery,
  useGetTemplateFieldsQuery,
  useGetTemplateQuery,
  useLazyGetTemplateQuery,
  useGetTemplateCollectionsQuery,
  useGetTemplatesUnassignedQuery,
} = templatesApi;
